import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getClassroom } from '../../../services/application/classroomService';
import { getApplications } from '../../../services/application/application';
import Table from '../../../components/Table/Table';
import { Button } from '../../../components/forms/Buttons/Button';
import { EyeIcon } from '@heroicons/react/24/outline';
const Classroom = () => {
  const [loading, setLoading] = useState(false);
  const [classroom, setClassroom] = useState(null);
  const { uuid } = useParams();
  const [applications, setApplications] = useState([]);

  const columns = React.useMemo(
    () => [
      {
        Header: 'ИИН',
        accessor: 'iin',
      },
      {
        Header: 'Аты',
        accessor: 'first_name',
      },
      {
        Header: 'Жөні',
        accessor: 'last_name',
      },
      {
        Header: 'Место',
        accessor: 'seat_id.seat_id',
      },
      {
        id: 'actions',
        Cell: (props) => (
          <div className='flex gap-2'>
            <Button
              Icon={EyeIcon}
              onClick={() => {
                window.open(`/students/${props.row.original.uuid}`, '_blank');
              }}
            />
          </div>
        ),
      },
    ],
    [],
  );

  useEffect(() => {
    if (uuid) {
      setLoading(true);
      Promise.all([
        getClassroom(uuid),
        getApplications({
          page_size: 500,
          classroom_id: uuid,
        }),
      ])
        .then(([classroom, applications]) => {
          setClassroom(classroom);
          setApplications(
            applications.results?.sort(
              (a, b) =>
                parseInt(a.seat_id.seat_id) - parseInt(b.seat_id.seat_id),
            ),
          );
        })
        ?.catch((err) => {
          console.error(err);
        })
        ?.finally(() => {
          setLoading(false);
        });
    }
  }, [uuid]);

  if (loading) {
    return (
      <div className='mx-auto max-w-7xl p-5'>
        <div className='mb-4 h-9 w-80 max-w-[60%] animate-shimmer rounded bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%]'></div>
        <div className='mb-4 h-7 w-64 max-w-[50%] animate-shimmer rounded bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%]'></div>
        <div className='mb-4 h-7 w-64 max-w-[50%] animate-shimmer rounded bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%]'></div>
        <div className='mb-4 h-7 w-64 max-w-[50%] animate-shimmer rounded bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%]'></div>
        <div className='mb-4 h-7 w-64 max-w-[50%] animate-shimmer rounded bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%]'></div>
        <div className='mt-6 rounded-lg border border-gray-200 bg-white p-4'>
          <div className='mb-3 h-12 w-full animate-shimmer rounded bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%]'></div>
          <div className='mb-3 h-12 w-full animate-shimmer rounded bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%]'></div>
          <div className='mb-3 h-12 w-full animate-shimmer rounded bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%]'></div>
          <div className='mb-3 h-12 w-full animate-shimmer rounded bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%]'></div>
          <div className='h-12 w-full animate-shimmer rounded bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%]'></div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <h1>Аудитория: {classroom?.classroom_id}</h1>
      <h2>Время экзамена: {classroom?.exam_time?.name}</h2>
      <h2>Экзам центр: {classroom?.exam_center?.name}</h2>
      <h2>Количество мест: {classroom?.seats_count}</h2>
      <h2>Количество занятых мест: {classroom?.occupied_seats_count}</h2>
      <Table columns={columns} data={applications} />
    </div>
  );
};

export default Classroom;
